import { network } from "apis";
import { isProd } from "../constants";
import {
  ExecutorVerificationStatus,
  ExecutorVerificationStep,
  ExecutorVerificationStepDetails,
} from "models/ExecutorVerification";
import { objectToCamel, objectToSnake } from "ts-case-convert"

export class KnowYourExecutorAPI {
  protected static baseURL = isProd
    ? "https://know-your-executor.weareatticus.com"
    : "https://know-your-executor-ppd1.weareatticus.com";

  protected static executorVerificationStatusCache:
    | ExecutorVerificationStatus[]
    | null = null;

  public static async fetchExecutorVerificationStatuses(
    allowCache = true
  ): Promise<ExecutorVerificationStatus[]> {
    if (allowCache && KnowYourExecutorAPI.executorVerificationStatusCache) {
      return KnowYourExecutorAPI.executorVerificationStatusCache;
    }

    const statuses: ExecutorVerificationStatus[] = [];
    try {
      const fullPath = `${KnowYourExecutorAPI.baseURL}/executor-verification-statuses`;
      const response = await network.callGet(fullPath);
      response?.data?.data?.forEach((status: ExecutorVerificationStatus) => {
        statuses.push(status);
      });

      KnowYourExecutorAPI.executorVerificationStatusCache = statuses;
    } catch (e: any) {
      console.error("couldn't fetch status list, " + e?.message);
    }

    return statuses;
  }

  public static async fetchExecutorVerificationSteps(): Promise<
    ExecutorVerificationStep[]
  > {
    const steps: ExecutorVerificationStep[] = [];
    try {
      const fullPath = `${KnowYourExecutorAPI.baseURL}/executor-verification-steps`;
      const response = await network.callGet(fullPath);
      response?.data?.data?.forEach((step: ExecutorVerificationStep) => {
        steps.push(step);
      });
    } catch (e: any) {
      console.error("couldn't fetch steps, " + e?.message);
    }

    return steps;
  }

  public static async fetchExecutorVerificationStepDetails(): Promise<
    ExecutorVerificationStepDetails[]
  > {
    const stepDetailsArray: ExecutorVerificationStepDetails[] = [];
    try {
      const fullPath = `${KnowYourExecutorAPI.baseURL}/executor-verification-step-details`;
      const response = await network.callGet(fullPath);
      response?.data?.data?.forEach(
        (stepDetails: ExecutorVerificationStepDetails) => {
          stepDetailsArray.push(stepDetails);
        }
      );
    } catch (e: any) {
      console.error("couldn't fetch step details, " + e?.message);
    }

    return stepDetailsArray;
  }

  public static async updateExecutorVerificationStep(step: ExecutorVerificationStep): Promise<ExecutorVerificationStep|null>
  {
    try {
      const fullPath = `${KnowYourExecutorAPI.baseURL}/executor-verification-steps`;
      const response = await network.callPost(fullPath, {...objectToSnake(step)});
      if(!response || (response && response.status !== 200)) {
        throw new Error("error fetching response, got status " + response?.status)
      }

      return response?.data?.data ? objectToCamel(response.data.data) as unknown as ExecutorVerificationStep : null
    } catch (e: any) {
      console.error("couldn't set step status, " + e?.message);
    }

    return null
  }

  public static async submitAllForReview(): Promise<boolean>
  {
    try {
      const fullPath = `${KnowYourExecutorAPI.baseURL}/executor-verification-ready`;
      const response = await network.callPost(fullPath);
      if(!response || (response && response.status !== 200)) {
        throw new Error("error fetching response, got status " + response?.status)
      }

      return true
    } catch (e: any) {
      console.error("couldn't set step status, " + e?.message);
    }

    return false
  }
}
